import React from 'react';
import * as styles from './styles.css';
import { Body1, Body2 } from '@cian/ui-kit';
import { Mapper } from '../../../../utils';
import clsx from 'clsx';

export interface IFactRowProps {
  title: string | null;
  subtitle?: string | null;
  imagePath: string | null;
  isMobile?: boolean;
}

export function FactRow({ title, subtitle, imagePath, isMobile }: IFactRowProps) {
  return (
    <div className={styles['container']}>
      <div className={clsx(styles['icon-wrapper'], isMobile && styles['icon-wrapper-mobile'])}>
        <Mapper icon={imagePath} />
      </div>
      <div className={styles['text-wrapper']}>
        <Body1>{title}</Body1>
        <Body2 color="text-secondary-default">{subtitle}</Body2>
      </div>
    </div>
  );
}
